// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__12a7M","socialButtons":"Login_socialButtons__3qryw","icon":"Login_icon__1N_PR"};